var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "-5.5 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66669 10C1.66669 5.39167 5.39169 1.66667 10 1.66667C14.6084 1.66667 18.3334 5.39167 18.3334 10C18.3334 14.6083 14.6084 18.3333 10 18.3333C5.39169 18.3333 1.66669 14.6083 1.66669 10ZM12.1584 6.66667L10 8.825L7.84169 6.66667L6.66669 7.84167L8.82502 10L6.66669 12.1583L7.84169 13.3333L10 11.175L12.1584 13.3333L13.3334 12.1583L11.175 10L13.3334 7.84167L12.1584 6.66667Z",
    fill: "#8596B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearIcon);
export default __webpack_public_path__ + "static/media/clear-icon.65efdaab5427585099857deba0e21a20.svg";
export { ForwardRef as ReactComponent };